import React from 'react'
import CountUp from 'react-countup'
import { heroImg } from '../../components/fodcAssets'

const Section1 = ({ onScroll }) => {
  return (
    <>
    <div className='container-fodc m-auto'>
        <div className='row'>
            <div className='col-lg-6 col-sm-12 text-data'>
                <p className='fodc-p-text'>Stop Losing Money to Third-Party Delivery</p>
                <p className='s-text'>Automate Your Dispute Resolution, Financial Reconciliation, Downtime Control & Reviews with Voosh.</p>
                <div className='btn btn-dark text-white fs-22' onClick={onScroll}>Join us as Food On Demand Conference</div>
            </div>
            <div className='col-lg-6 col-sm-12'>
                <div className='img-wrap'>
                    <img className='brand-bg' src={heroImg} alt='Stop Losing Money to Third-Party Delivery' />
                </div>
            </div>
        </div>
    </div>
    <div style={{backgroundColor:"#FAFAFA"}}>
        <div className='row justify-content-between fodc-s2'>
            <div className='col-lg-3 col-sm-12'>
                <p className='t1 color-brand'>$<CountUp delay={0.2} start={0.1} end={2.5} decimals={1} duration={6} />M+</p>
                <p className='t2 w-75'>saved for 100+ restaurant brands</p>
            </div>
            <div className='col-lg-3 col-sm-12'>
                <p className='t1 color-brand'><CountUp delay={0.2} start={0} end={250} duration={6} />K+</p>
                <p className='t2 w-75'>disputes appealed across restaurant brands</p>
            </div>
            <div className='col-lg-3 col-sm-12'>
                <p className='t1 color-brand'><CountUp delay={0.2} start={0} end={4300} duration={6} />+</p>
                <p className='t2 w-75'>hours of manual work eliminated</p>
            </div>
            <div className='col-lg-3 col-sm-12'>
                <p className='t1 color-brand'>2-6%</p>
                <p className='t2 w-75'>order disputes average</p>
            </div>
        </div>
    </div>
    </>
  )
}

export default Section1